export default "__VITE_ASSET__B8Gk8GEJ__"